module.exports = __webpack_public_path__ + "img/gamification-rtc-image.74e01d4d.png";